export class FinanceDistributorDialogModel {
    constructor(
        public distirbutorName: any
    ) {}
}